import { TreatIcon } from "../components/TreatIcon";

export function PricingHero() {
  return (
    <section className="relative overflow-hidden px-[clamp(24px,5vw,80px)] pt-[clamp(48px,7vw,88px)] pb-[clamp(24px,4vw,40px)] text-center">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -top-32 left-1/2 z-0 h-[600px] w-[900px] -translate-x-1/2 rounded-full bg-[radial-gradient(circle,rgba(165,180,252,0.35)_0%,transparent_60%)]"
      />
      <div className="relative z-[1] mx-auto max-w-[820px]">
        <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-indigo-200 bg-white px-3.5 py-1.5 text-xs font-semibold uppercase tracking-[0.08em] text-indigo-700 shadow-[0_6px_18px_-10px_rgba(99,102,241,0.4)]">
          <TreatIcon size={14} />
          Pricing
        </div>
        <h1 className="font-companion mb-6 text-[clamp(40px,5.5vw,64px)] font-bold leading-[1.05] tracking-[-0.03em] text-primary [text-wrap:balance]">
          Pay for the work. <br />
          <span className="text-indigo-600">Not the seat.</span>
        </h1>
        <p className="mx-auto max-w-[640px] text-[clamp(16px,1.6vw,19px)] leading-[1.55] text-secondary [text-wrap:pretty]">
          Companion has its own pricing, separate from your Scribenote plan —
          but{" "}
          <strong className="text-primary">
            you&apos;ll need a Scribenote account to get started
          </strong>
          . Every new signup gets 500 free Treats to start.
        </p>
      </div>
    </section>
  );
}
